import React from 'react';
import { SvgIcon } from '@onsolve/onsolve-ui-components';

const TopicsImage = props => (
    <SvgIcon {...props}>
        <path
            d="M8.338 2.06l.018.01L16 6.485v7.54l-1.128 1.953a1.394 1.394 0 01-.253.023h-5.17l-1.852-1.069a.262.262 0 00-.35.083l-.008.013a.262.262 0 00.083.35l.014.008L8.402 16h-7.25a1.38 1.38 0 01-1.116-.568l.013-.023L7.64 2.262a.524.524 0 01.68-.21l.019.009zm-4.28 11.13a.786.786 0 101.362.784.786.786 0 00-1.363-.784zm5.013-1.337a.262.262 0 00.083.35l.014.008 3.636 2.1a.262.262 0 10.262-.454l-3.636-2.1a.262.262 0 00-.359.096zm1.833-3.173a.262.262 0 00.083.35l.013.008 3.636 2.099a.262.262 0 10.262-.454l-3.636-2.099a.262.262 0 00-.358.096zM5.822 9.763a.261.261 0 00-.189.306l.004.015.192.715a.262.262 0 00.304.19l.018-.004 2.149-.573a.263.263 0 00-.121-.51l-.016.004-1.895.505-.125-.462a.263.263 0 00-.321-.186zM7.654 6.59a.26.26 0 00-.189.305l.004.015.193.716a.261.261 0 00.304.19l.017-.005 2.149-.572a.263.263 0 00-.121-.51l-.015.004-1.896.505-.125-.463a.263.263 0 00-.321-.185z"
            stroke="none"
            fillRule="nonzero"
        />
    </SvgIcon>
);

export default TopicsImage;
